<template>
  <div
    v-if="$store.state.successNotif"
    class="bg-green-200 absolute right-20 bottom-20 rounded-md text-white-900"
  >
    <div class="relative px-10 py-5">
      <button
        @click="_hidden"
        class="bg-white absolute top-1 right-1 rounded-full w-6 h-6 font-bold flex items-center justify-center"
      >
        x
      </button>
      <fas icon="check-circle" /> {{ $store.state.successMessage }}
    </div>
  </div>
</template>

<script>
export default {
  name: "SuccessNotif",
  methods: {
    _hidden: function() {
      this.$store.dispatch("success", {
        isSuccess: false,
        message: "",
      });
    },
  },
};
</script>
